/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function DeviceBulkProvisioningController($mdDialog, $stateParams, $q, $translate, types, entityTableConfiguration,
                                                         importExport, entityService, deviceService) {
    var vm = this;

    vm.$onInit = function () {
        vm.fileContent = undefined;
        vm.headerColumns = [];

        vm.deviceModels = [];

        vm.selectedDeviceModel = undefined;
        vm.selectedColumnValueForName = [];
        vm.deviceAddressColumn = undefined;
        vm.appEuiColumn = undefined;
        vm.appKeyColumn = undefined;
        vm.useAppNetworkSettings = false;
        vm.applicationAbp = false;
        vm.apb = false;
        vm.selectedColumnValueForDescription = [];

        vm.addAllOtherColumnsToDescription = true;

        vm.provisioningResult = '';
        vm.numberOfCreatedDevices = 0;

        vm.idIncrementor = 0;

        vm.close = close;
        vm.importFromCsv = importFromCsv;
        vm.startProvisioning = startProvisioning;
        vm.transformChipsForNamePattern = transformChipsForNamePattern;

        entityService.getEntities(types.entityType.device_model).then(
            (deviceModels) => {
                vm.deviceModels = deviceModels;
            }
        );
    };

    function close() {
        $mdDialog.cancel();
    }

    function importFromCsv($event) {
        importExport.uploadFile($event, types.fileType.CSV,
            'bulk-provisioning.import-data', 'bulk-provisioning.result-file').then(
            (csvData) => {
                vm.fileContent = csvData;
                vm.headerColumns = vm.fileContent.split(/\r?\n/)[0].split(',');
            },
            function fileSelectCanceled() {
            });
    }

    function startProvisioning() {
        var rows = vm.fileContent.split(/\r?\n/);
        var rowValues = [];
        var tasks = [];

        for (var i = 1; i < rows.length; i++) {
            rowValues = rows[i].split(',');
            if (vm.headerColumns.length === rowValues.length) {
                var deviceEui = getFieldValue(vm.headerColumns, rowValues, types.bulk_provisioning.device_eui_column);
                var deviceName = getDeviceName(vm.headerColumns, rowValues, vm.selectedColumnValueForName);
                var deviceAddress = getDeviceName(vm.headerColumns, rowValues, vm.deviceAddressColumn);
                var appEui = getFieldValue(vm.headerColumns, rowValues, vm.appEuiColumn);
                var appKey = getFieldValue(vm.headerColumns, rowValues, vm.appKeyColumn);

                var columnsToSkip = vm.selectedColumnValueForName.map(columnName => columnName.name).slice();
                columnsToSkip.push(types.bulk_provisioning.device_eui_column);
                columnsToSkip.push(vm.appEuiColumn);
                columnsToSkip.push(vm.appKeyColumn);

                var deviceDescription = getDeviceDescription(vm.headerColumns, rowValues, columnsToSkip);
                tasks.push(createDevice(deviceEui, deviceName, deviceAddress, deviceDescription, appEui, appKey));
            } else if (rowValues.length === 1 && !rowValues[0].trim().length) {
                // Do not show a warning if a processed file's line is empty, continue to process the next line.
            } else {
                vm.provisioningResult = $translate.instant('bulk-provisioning.wrong-column-number', {
                    numberOfCellsInRow: rowValues.length,
                    rowNumber: i,
                    numberOfCellsInHeader: vm.headerColumns.length,
                }) + '\n';
            }
        }

        $q.all(tasks).then(() => {
            vm.provisioningResult += '\n' + $translate.instant('bulk-provisioning.result', {
                count: vm.numberOfCreatedDevices,
                entityType: $translate.instant('device.devices')
            });
            entityTableConfiguration.reloadEntities();
        });
    }

    function getFieldValue(headerColumns, rowValues, columnName) {
        var deviceEuiColumnIdx = headerColumns.indexOf(columnName);
        return rowValues[deviceEuiColumnIdx];
    }

    function getDeviceName(headerColumns, rowValues, columnsToComposeDeviceName) {
        var deviceName = '';

        for (var i = 0; i < columnsToComposeDeviceName.length; i++) {
            var columnIdx = headerColumns.indexOf(columnsToComposeDeviceName[i].name);
            var columnValue = columnsToComposeDeviceName[i].name;

            // If name part isn't equal to any of header columns, then it's raw value is used.
            if (columnIdx !== -1) {
                columnValue = rowValues[columnIdx];
            }
            deviceName += columnValue;
        }
        return deviceName;
    }

    function getDeviceDescription(headerColumns, rowValues, columnsToSkip) {
        var deviceDescription = [];
        for (var i = 0; i < rowValues.length; i++) {
            var columnName = headerColumns[i];
            if (!columnsToSkip.includes(columnName)) {
                if (vm.addAllOtherColumnsToDescription) {
                    deviceDescription.push(`${columnName} - ${rowValues[i]}`);
                } else {
                    if (vm.selectedColumnValueForDescription.includes(columnName)) {
                        deviceDescription.push(`${columnName} - ${rowValues[i]}`);
                    }
                }
            }
        }
        return deviceDescription.join('\n');
    }

    function createDevice(eui, name, address, descriprion, appEui, appKey) {
        var data = {
            deviceModelId: {
                entityType: types.entityType.device_model,
                id: vm.selectedDeviceModel.id.id
            },
            name: name,
            deviceEUI: eui,
            deviceAddress: address,
            appEUI: appEui,
            appKey: appKey,
            applicationId: {
                entityType: types.entityType.deviceGroup,
                id: $stateParams.applicationId
            },
            abp: vm.apb,
            applicationAbp: vm.applicationAbp,
            useAppNetworkSettings: vm.useAppNetworkSettings,
            additionalInfo: {
                description: descriprion
            }
        };

        data.networkSettings = {
            rxWindow: 0,
            rxDelay: 0,
            fcntCheck: true,
            rx2DataRate: 0,
            rx1DataRateOffset: 0,
            adrInterval: 0,
            installationMargin: 0,
            cfList: []
        };
        data.apiLimits = {
            enabled: false,
            timeUnit: types.apiLimitTimeUnit.days,
            timeValue: 1,
            limit: 2147483647
        };

        var deferred = $q.defer();
        deviceService.saveDeviceBulkProvisioning(data).then(
            () => {
                vm.numberOfCreatedDevices++;
                deferred.resolve();
            },
            (error) => {
                vm.provisioningResult += error.data.message + '\n';
                deferred.resolve();
            });
        return deferred.promise;

    }

    function transformChipsForNamePattern(chip) {
        return {
            id: ++vm.idIncrementor,
            name: chip
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/device/bulk-provisioning/bulk-provisioning.controller.js